<template>
    <v-card>
        <v-form v-model="valid" ref="addPremiseForm" @submit="save" onSubmit="return false">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Create Premises</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-layout>
                        <v-flex md4>
                            <v-text-field label="Name"
                                          v-model="premise.name"
                                          counter="100"
                                          ref="premiseName"
                                          :rules="serverValidation('name','Premise Name')"
                                          ></v-text-field>
                        </v-flex>
                        <v-flex md4>
                            <v-text-field label="Sub Name"
                                          v-model="premise.subName"
                                          counter="100"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4 v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                            <v-select :items="cadConfigurations"
                                      label="CAD Configuration"
                                      item-text="description"
                                      v-model="premise.cadConfigurationId"
                                      hint="Overrides Organization Config If Selected"
                                      persistent-hint
                                      item-value="id"></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex md9>
                            <v-text-field label="Address"
                                          v-model="premise.address"
                                          counter="100"></v-text-field>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field label="Number of Floors"
                                          v-model="premise.numberOfFloors"
                                          type="number"
                                          counter="100"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex md4>
                            <v-text-field label="Emergency Number"
                                          type="number"
                                          v-model="premise.emergencyNumber"
                                          counter="100"></v-text-field>
                        </v-flex>
                        <v-flex md4>
                            <v-text-field label="Interval Minutes"
                                          type="number"
                                          v-model="premise.intervalMinutes"
                                          counter="3"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn class="mx-2" outlined type="button" @click="cancel()" color="warning" :disabled="overlay">Cancel</v-btn>
                <v-btn class="mx-2" outlined type="submit" @click="save()" color="success" :disabled="overlay">Save</v-btn>
                <v-progress-circular
                        :width="3"
                        v-show="overlay"
                        color="red"
                        indeterminate="">
                </v-progress-circular>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>

    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'

    export default {
        mixins:[validationMixin],
        props: {
            organizationId: {
                type:Number,
                required:true
            }
        },
        data() {
            return {
                cadConfigurations: [],
                overlay: false,
                valid: false,
                premise: {},
                premiseRules : [
                    v => { if (v && v.length > 0) {return true;} return 'Premise Name is Required' }
                ],
            }
        },
        mounted() {
            if (this.$permissionHolder.hasPermission('GLOBAL_ADMIN')) {
                api.cadConfig.search().then((data) => {
                    this.cadConfigurations = data.list;
                });
            }
        },
        methods: {
            open() {
                this.reset();
                this.$nextTick(this.$refs.premiseName.focus);
            },
            reset() {
                this.premise = {};
                this.violations = [];
            },
            save() {
                this.overlay = true;
                this.premise.organizationId = this.organizationId;

                if (!this.$permissionHolder.hasPermission('GLOBAL_ADMIN')) {
                    this.premise.cadConfigurationId == null;
                }

                api.premise.post(this.premise).then((premise) => {
                    //this.$router.replace('/premise/'+premise.id);
                    this.reset();
                    this.$emit('saved',premise);
                    this.$root.$emit('globalMessage','Premise Saved');
                }, (error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.addPremiseForm.validate();
                    }
                }).finally(() => this.overlay = false);
            },
            cancel() {
                this.$emit('cancelled');
            }
        }
    }

</script>